import { render, staticRenderFns } from "./Lgx297738824396570624.vue?vue&type=template&id=15a7bdce&scoped=true&"
import script from "./Lgx297738824396570624.vue?vue&type=script&lang=js&"
export * from "./Lgx297738824396570624.vue?vue&type=script&lang=js&"
import style0 from "./Lgx297738824396570624.vue?vue&type=style&index=0&id=15a7bdce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a7bdce",
  null
  
)

export default component.exports